import React from 'react';
import { NavigationItem } from 'ui-toolkit';
import { positiveDocumentDownloadUrl } from '../../../utilities/vendorDashboard/positiveDocumentDownloadUrl';
import { IStandardDocumentData } from '../../../types/order/documents/shared/interfaces';
import {
  defaultNormalizedDocumentCategoriesData,
  useListDocumentCategoriesQuery,
} from '../../../API/documentCategories/DocumentCategoriesApi';
import { downloadFile } from '../../../ui-toolkit/utilities/downloadFile';

interface IDocumentActivityCellProps {
  document: IStandardDocumentData;
  orderId: string;
}

export const ClientDocumentActivityCell: React.FC<IDocumentActivityCellProps> = ({ document, orderId }) => {
  const { data: { allCategories } = defaultNormalizedDocumentCategoriesData } = useListDocumentCategoriesQuery();

  return (
    <NavigationItem
      text={'Download'}
      onClick={() => downloadFile(positiveDocumentDownloadUrl(orderId, document, allCategories), document.fileName)}
      isActive
    />
  );
};
